export default __webpack_public_path__ + "static/media/airfreight-banner.dedc35ad.png";